import React from "react";

const Maintenance = () => {
  return (
    <div class="min-h-screen bg-slate-50 flex items-center justify-center p-6 font-sans">
      <div class="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-10 md:p-14 max-w-lg w-full text-center space-y-8 border border-slate-100">
        <div className="text-5xl mb-6">🛠️</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Platform Maintenance
        </h1>

        <p class="text-slate-500 text-lg leading-relaxed">
          The Gig Life Pro platform is{" "}
          <span class="font-semibold text-slate-700">
            currently offline for scheduled maintenance.
          </span>
        </p>

        <div class="bg-red-50/80 border border-red-100 rounded-2xl p-5">
          <p class="text-red-700 text-sm md:text-base font-medium leading-relaxed">
            Logins and all actions are temporarily unavailable. We expect to be
            back online <span class="font-bold">12:00SGT 13 April 2026</span>.
          </p>
        </div>

        <p class="text-slate-400 text-sm font-medium pt-2">
          Thank you for your patience!
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
